import React from 'react';
import { useTranslation } from 'react-i18next';

const ComingSoon = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 flex items-start justify-center px-4 pt-20">
      <div className="max-w-md mx-auto text-center">


        {/* Content */}
        <div className="bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-2xl font-semibold text-gray-900 mb-4">
            {t('comingSoon.title')}
          </h1>
          
                     <p className="text-gray-600">
             {t('comingSoon.description')}
           </p>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
